import React, { Component } from "react";
import { Container } from "reactstrap";
import { RouterProps, Styled } from "../../../../toolkit/decorators/Artifact";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./ReporteGerenteGeneral.form";
import { MemoTable } from "./ReporteGerenteGeneral.table";
import FormBuilderModal from "../../common/formBuilderModal/formBuilderModal";
import { cambiarVendedorFormConfig } from "./ReporteGerenteGeneralVendedor.form";
import { ReporteGerenteGeneralDispatcher } from "../../../containers/comisionesMembresia/reporteGerenteGeneral/ReporteGerenteGeneral.dispatcher";
import { ReporteGerenteGeneralStore } from "../../../containers/comisionesMembresia/reporteGerenteGeneral/ReporteGerenteGeneral.store";
import MembresiaSnapshot from "../../../../types/MembresiaSnapshot";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Preview } from "../../../../types/IAction";
import { GetSnapshot } from "../../../reducers/comisionMembresia";
import {
  downloadSnapshotByAsesor,
  downloadSnapshotByFolioFactura,
  downloadSnapshotByPeriodo
} from "../../../actions/comisionMembresia";
import ConfirmModal from "../../common/confirmModal/confirmModal";
import s from "./styles.scss";

interface Props
  extends ReporteGerenteGeneralDispatcher,
    ReporteGerenteGeneralStore,
    RouterProps {}

interface State {
  downloading: boolean;
  tipoBusqueda: string;
  filters: Inputs & {
    periodo: string;
    page: number;
    size: number;
  };

  row: MembresiaSnapshot;
  actualizarPopupOpen: boolean;
  cambiarVendedorPopupOpen: boolean;
  descartarPopupOpen: boolean;
}

@Styled(s)
export default class ReporteGerenteGeneralComponent extends Component<
  Props,
  State
> {
  state = {
    downloading: false,
    tipoBusqueda: "",
    filters: {
      periodo: null,
      page: 0,
      size: 100
    } as any,
    currentResumen: null,

    row: null as MembresiaSnapshot,
    actualizarPopupOpen: false,
    cambiarVendedorPopupOpen: false,
    descartarPopupOpen: false
  };

  componentDidMount(): void {
    this.props.clearSnapshot();
    this.props.clearResumen();
  }

  clear = () => {
    this.setState({
      tipoBusqueda: "",
      filters: {
        page: 0,
        size: 100
      } as any
    });
  };

  fetchData = async ({ page, pageSize }) => {
    const { tipoBusqueda, filters } = this.state;
    const params = {
      ...filters,
      page,
      size: pageSize
    };

    let preview: Preview<GetSnapshot>;

    if (!tipoBusqueda) {
      preview = await this.props.getSnapshotByPeriodo(
        params.periodo,
        params.idClub,
        params.tipoOperacion,
        params.conCambios,
        params.evaluadorModifico,
        params.sinCumplimiento,
        params.page,
        params.size
      );
    } else if (tipoBusqueda === "factura") {
      preview = await this.props.getSnapshotByFolioFactura(
        params.folioFactura,
        params.page,
        params.size
      );
    } else {
      preview = await this.props.getSnapshotByAsesor(
        params.periodo,
        params.idVendedor,
        params.page,
        params.size
      );
    }

    if (!preview.fulfilled) {
      errorNotification(preview.gettingSnapshotError);
    }
  };

  submit = (data: { [key in Inputs]: any }) => {
    this.setState(
      {
        tipoBusqueda: data.tipoBusqueda,
        filters: {
          ...data,
          periodo: `${data.anio || new Date().getFullYear()}-${data.mes}-01`,
          page: 0,
          size: 100
        } as any
      },
      () => this.fetchData({ page: 0, pageSize: 100 })
    );
  };

  handleExport = async () => {
    const { tipoBusqueda, filters } = this.state;
    this.setState({ downloading: true });

    if (!tipoBusqueda) {
      downloadSnapshotByPeriodo(
        filters.periodo,
        filters.idClub,
        filters.tipoOperacion,
        filters.conCambios,
        filters.evaluadorModifico,
        filters.sinCumplimiento,
        () => this.setState({ downloading: false })
      );
    } else if (tipoBusqueda === "factura") {
      downloadSnapshotByFolioFactura(filters.folioFactura, () =>
        this.setState({ downloading: false })
      );
    } else {
      downloadSnapshotByAsesor(filters.periodo, filters.idVendedor, () =>
        this.setState({ downloading: false })
      );
    }
  };

  handleActualizarSnapshot = (row: MembresiaSnapshot) => {
    this.setState({
      actualizarPopupOpen: true,
      row: row
    });
  };

  handleActualizarSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putSnapshotEvaluacion(
      row.idCotizacionItem,
      {
        modo: data.modo,
        observaciones: data.observaciones,
        idMembresiaActualizacion: data.idMembresiaActualizacion
          ? parseInt(data.idMembresiaActualizacion as any)
          : null,
        tipoOperacionActualizacion: data.tipoOperacionActualizacion || null
      }
    );

    if (preview.fulfilled) {
      successNotification("La membresía se configuró correctamente");

      this.setState({
        actualizarPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(preview.puttingSnapshotEvaluacionError);
    }
  };

  handleCambiarVendedor = (row: MembresiaSnapshot) => {
    this.setState({
      row,
      cambiarVendedorPopupOpen: true
    });
  };

  handleCambiarVendedorSubmit = async data => {
    const { row } = this.state;
    const preview = await this.props.putCambiarVendedor(row.idCotizacionItem, {
      idVendedor: parseInt(data.idVendedor as any),
      razonCambioVendedor: data.razonCambioVendedor
    });

    if (preview.fulfilled) {
      successNotification("Vendedor actualizado correctamente");

      this.setState({
        cambiarVendedorPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(preview.puttingCambiarVendedorError);
    }
  };

  handleDescartarCambios = (row: MembresiaSnapshot) => {
    this.setState({
      row,
      descartarPopupOpen: true
    });
  };

  handleDescartarConfirm = async () => {
    const { row } = this.state;
    const result = await this.props.deleteSnapshotEvaluacion(
      row.idCotizacionItem
    );

    if (result.fulfilled) {
      successNotification("Los cambios se descartaron correctamente");

      this.setState({
        descartarPopupOpen: false,
        row: null
      });
      this.fetchData({
        page: this.state.filters.page,
        pageSize: this.state.filters.size
      });
    } else {
      errorNotification(result.deletingSnapshotEvaluacionError);
    }
  };

  render() {
    const { row, cambiarVendedorPopupOpen, descartarPopupOpen } = this.state;

    return (
      <Container>
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.submit}
          processing={
            this.props.gettingSnapshot ||
            this.props.gettingResumenSnapshot ||
            this.props.postingSnapshotByPeriodo ||
            this.state.downloading
          }
        />

        {this.props.snapshot && (
          <MemoTable
            page={this.props.snapshot}
            loading={
              this.props.gettingSnapshot ||
              this.props.gettingResumenSnapshot ||
              this.props.postingSnapshotByPeriodo ||
              this.state.downloading
            }
            onFetchData={this.fetchData}
            onExport={this.handleExport}
            onActualizarSnapshot={this.handleActualizarSnapshot}
            onCambiarVendedor={this.handleCambiarVendedor}
            onDescartarCambios={this.handleDescartarCambios}
          />
        )}

        <FormBuilderModal
          isOpen={cambiarVendedorPopupOpen}
          title={`Vendedor de Cotización ${!!row && row.idCotizacionItem}`}
          message={""}
          ok={this.handleCambiarVendedorSubmit}
          cancel={() => this.setState({ cambiarVendedorPopupOpen: false })}
          formConfig={cambiarVendedorFormConfig}
          values={{
            idVendedor: (row && row.idVendedor) || "",
            razonCambioVendedor: ""
          }}
        />

        <ConfirmModal
          isOpen={descartarPopupOpen}
          title={`Reestablecer Cotización ${!!row && row.idCotizacionItem}`}
          message={"Los cambios detectados y sus comentarios serán ignorados."}
          ok={this.handleDescartarConfirm}
          cancel={() => this.setState({ descartarPopupOpen: false })}
          size={"md"}
          waiting={this.props.deletingSnapshotEvaluacion}
        />
      </Container>
    );
  }
}
